'use strict';

import ngResource from 'angular-resource';

function CompareBookmarkService($resource) {
  return $resource(
    '/api/compare_bookmark/:id',
    { id: '@id' },
    {
      index :  { method: 'GET',  isArray: true  },
      show  :  { method: 'GET',  isArray: false },
      create:  { method: 'POST', isArray: false },
      destroy: { method: 'DELETE',  isArray: false }
    }
  );
}

export default angular.module('leptonApp.CompareBookmarkService', ['ngResource'])
  .service('CompareBookmarkService', ['$resource', CompareBookmarkService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/compare_bookmark/compare_bookmark.service.js